import { useOidc } from "@axa-fr/react-oidc"
import { faChevronRight } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Button } from "@janeapp/burrito-design-system"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { ErrorRefreshFallback } from "../../components/ErrorRefreshFallback"
import { PanelButton } from "../../components/PanelButton"
import { KeycloakContext } from "../../context/KeycloakContext"

const chevronButton = (
  <button>
    <FontAwesomeIcon icon={faChevronRight} />
  </button>
)

export const EmailPassword = () => {
  const { login } = useOidc()
  const { t, i18n } = useTranslation()
  const { userCredentials, error } = useContext(KeycloakContext)
  const email = userCredentials?.email || ""
  const emailPasswordError = error?.userCredentialError

  const currentLocale = i18n.language
  return (
    <div>
      {emailPasswordError ? (
        <ErrorRefreshFallback />
      ) : (
        <>
          <Button>Hi</Button>
          <PanelButton
            className="rounded-t p-6 flex justify-between items-center bg-white"
            title={t("loginSecurity.loginEmail")}
            subtitle={email}
            interactiveButton={chevronButton}
            borderBottomNone
            onClick={() =>
              login(undefined, {
                kc_action: "UPDATE_EMAIL",
                ui_locales: currentLocale,
              })
            }
          />
          <PanelButton
            className="rounded-b p-6 flex justify-between items-center bg-white"
            title={t("loginSecurity.password")}
            subtitle={t("loginSecurity.lastChanged")}
            interactiveButton={chevronButton}
            onClick={() =>
              login(undefined, {
                kc_action: "UPDATE_PASSWORD",
                ui_locales: currentLocale,
              })
            }
          />
        </>
      )}
    </div>
  )
}
